// ── MOBILE NAV ──
const hamburger = document.querySelector('.hamburger');
const mobileNav = document.querySelector('.mobile-nav');
const mobileClose = document.querySelector('.mobile-nav-close');
if (hamburger && mobileNav) {
  hamburger.addEventListener('click', () => {
    mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}
if (mobileClose && mobileNav) {
  mobileClose.addEventListener('click', () => {
    mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  });
}

// ── CART COUNT ──
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count > 0 ? `(${count})` : '';
      });
    });
}
updateCartCount();

// ── AJAX ADD TO CART ──
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.product-add');
  if (!btn) return;
  e.preventDefault();

  // Find the variant ID from closest product card link
  const card = btn.closest('a.product-card, a.top-seller-main, a.top-seller-small');
  if (!card) return;

  // Extract variant ID from the product URL via fetch
  const productUrl = card.href;
  if (!productUrl || productUrl.includes('/collections')) return;

  btn.textContent = '...';
  btn.disabled = true;

  // Fetch the product JSON to get the first variant ID
  const productJsonUrl = productUrl.split('?')[0] + '.json';
  fetch(productJsonUrl)
    .then(r => r.json())
    .then(data => {
      const variantId = data.product.variants[0].id;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓';
      btn.style.background = 'var(--gold-light)';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = '+';
        btn.style.background = '';
        btn.disabled = false;
      }, 1500);
    })
    .catch(() => {
      // If AJAX fails, just navigate to the product page
      window.location = card.href;
    });
});

// ── EMAIL SUBSCRIBE ──
const emailForm = document.querySelector('.email-form');
if (emailForm) {
  const btn = emailForm.querySelector('button');
  const input = emailForm.querySelector('input');
  if (btn && input) {
    btn.addEventListener('click', () => {
      if (input.value.includes('@')) {
        input.value = '';
        input.placeholder = "✓ You're on the list!";
        setTimeout(() => { input.placeholder = 'your@email.com'; }, 3000);
      }
    });
  }
}

// Position color swatch tooltips on hover to avoid clipping
document.querySelectorAll('.color-swatch').forEach(swatch => {
  const label = swatch.querySelector('.swatch-label');
  if (!label) return;
  swatch.addEventListener('mousemove', function(e) {
    label.style.left = e.clientX + 'px';
    label.style.top = (e.clientY - 8) + 'px';
  });
});

// Add to cart for featured product cards
function addFeaturedToCart(handle, btn) {
  const original = btn.textContent;
  btn.textContent = '...';
  btn.disabled = true;

  fetch('/products/' + handle + '.json')
    .then(r => r.json())
    .then(data => {
      const variantId = data.product.variants[0].id;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓ Added!';
      btn.style.background = 'var(--gold-light)';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(() => {
      btn.textContent = original;
      btn.disabled = false;
    });
}

// Fix Easify labels - only target option title labels, never swatch elements
function fixEasifyLabels() {
  document.querySelectorAll('.form__label, .tpo_undefined').forEach(el => {
    // Skip ANY element inside a swatch container
    if (
      el.closest('[class*="po-color"]') ||
      el.closest('[class*="po-swatch"]') ||
      el.closest('[class*="po-option"]') ||
      el.classList.toString().includes('po-')
    ) return;
    el.style.setProperty('color', '#f0a500', 'important');
    el.style.fontSize = '11px';
    el.style.fontWeight = '700';
    el.style.letterSpacing = '.12em';
    el.style.textTransform = 'uppercase';
  });
}

// Run on load and observe for Easify dynamic injection
fixEasifyLabels();
const easifyObserver = new MutationObserver(fixEasifyLabels);
easifyObserver.observe(document.body, { childList: true, subtree: true });

// ── FREE SHIPPING PROGRESS BAR ──
const FREE_SHIPPING_THRESHOLD = 3500; // $35.00 in cents

function updateShippingBar() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const bar = document.getElementById('shippingBar');
      const fill = document.getElementById('shippingBarFill');
      const text = document.getElementById('shippingBarText');
      if (!bar || !fill || !text) return;

      const total = cart.total_price;
      const remaining = FREE_SHIPPING_THRESHOLD - total;
      const pct = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);

      fill.style.width = pct + '%';

      if (total >= FREE_SHIPPING_THRESHOLD) {
        text.innerHTML = '🎉 <span>You\'ve unlocked FREE shipping!</span>';
        fill.style.background = 'var(--gold)';
      } else {
        const remainingFormatted = '$' + (remaining / 100).toFixed(2);
        text.innerHTML = 'Add <span>' + remainingFormatted + '</span> more for FREE shipping!';
      }
    })
    .catch(() => {
      const bar = document.getElementById('shippingBar');
      if (bar) bar.style.display = 'none';
    });
}

updateShippingBar();

// ── BACK TO TOP ──
const backToTop = document.getElementById('backToTop');
if (backToTop) {
  window.addEventListener('scroll', () => {
    backToTop.classList.toggle('visible', window.scrollY > 400);
  });
  backToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// ── IMAGE ZOOM ──
const zoomOverlay = document.getElementById('imgZoomOverlay');
const zoomImg = document.getElementById('imgZoomImg');
const zoomClose = document.getElementById('imgZoomClose');
const mainProductImg = document.getElementById('mainProductImg');

if (mainProductImg && zoomOverlay) {
  mainProductImg.addEventListener('click', function() {
    zoomImg.src = this.src.replace('&width=800', '&width=1600').replace('width=800', 'width=1600');
    zoomOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  zoomOverlay.addEventListener('click', function(e) {
    if (e.target === zoomOverlay || e.target === zoomClose) {
      zoomOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
  if (zoomClose) zoomClose.addEventListener('click', () => {
    zoomOverlay.classList.remove('open');
    document.body.style.overflow = '';
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { zoomOverlay.classList.remove('open'); document.body.style.overflow = ''; }
  });
}

// ── STICKY ADD TO CART ──
const stickyAtc = document.getElementById('stickyAtc');
const stickyAtcBtn = document.getElementById('stickyAtcBtn');
const stickyAtcTitle = document.getElementById('stickyAtcTitle');
const stickyAtcPrice = document.getElementById('stickyAtcPrice');
const mainAtcBtn = document.querySelector('.product-page-atc');

if (stickyAtc && mainAtcBtn) {
  // Populate title and price from page
  const productTitle = document.querySelector('.product-page-title');
  const productPrice = document.getElementById('productPrice');
  if (productTitle) stickyAtcTitle.textContent = productTitle.textContent;
  if (productPrice) stickyAtcPrice.textContent = productPrice.textContent;

  // Update sticky price when variant changes
  if (productPrice) {
    const priceObserver = new MutationObserver(() => {
      stickyAtcPrice.textContent = productPrice.textContent;
    });
    priceObserver.observe(productPrice, { childList: true, subtree: true, characterData: true });
  }

  // Show sticky bar when main ATC scrolls out of view
  const atcObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      stickyAtc.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  atcObserver.observe(mainAtcBtn);

  // Sticky ATC button submits the main form
  stickyAtcBtn.addEventListener('click', () => {
    mainAtcBtn.click();
  });
}




// ── EASIFY LABEL COLOR FIX ──
// Only targets option title labels, never swatch elements
function fixEasifyLabels() {
  document.querySelectorAll('.form__label, .tpo_undefined').forEach(el => {
    if (el.closest('[class*="po-"]')) return; // Skip swatch elements
    el.style.setProperty('color', '#f0a500', 'important');
  });
}
fixEasifyLabels();
const easifyLabelObserver = new MutationObserver(fixEasifyLabels);
easifyLabelObserver.observe(document.body, { childList: true, subtree: true });
